import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M8.5 6C8.5 5.44772 8.94772 5 9.5 5C10.0523 5 10.5 5.44772 10.5 6C10.5 6.55228 10.0523 7 9.5 7C8.94772 7 8.5 6.55228 8.5 6Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1.5 6C1.5 5.44772 1.94772 5 2.5 5C3.05228 5 3.5 5.44772 3.5 6C3.5 6.55228 3.05228 7 2.5 7C1.94772 7 1.5 6.55228 1.5 6Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.66667 8.00033C6.66667 7.26395 7.26362 6.66699 8 6.66699C8.73638 6.66699 9.33333 7.26395 9.33333 8.00033C9.33333 8.73671 8.73638 9.33366 8 9.33366C7.26362 9.33366 6.66667 8.73671 6.66667 8.00033Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M11.3333 8.00033C11.3333 7.26395 11.9303 6.66699 12.6667 6.66699C13.403 6.66699 14 7.26395 14 8.00033C14 8.73671 13.403 9.33366 12.6667 9.33366C11.9303 9.33366 11.3333 8.73671 11.3333 8.00033Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M2 8.00033C2 7.26395 2.59695 6.66699 3.33333 6.66699C4.06971 6.66699 4.66667 7.26395 4.66667 8.00033C4.66667 8.73671 4.06971 9.33366 3.33333 9.33366C2.59695 9.33366 2 8.73671 2 8.00033Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.33333 9.99967C8.33333 9.0792 9.07952 8.33301 10 8.33301C10.9205 8.33301 11.6667 9.0792 11.6667 9.99967C11.6667 10.9201 10.9205 11.6663 10 11.6663C9.07952 11.6663 8.33333 10.9201 8.33333 9.99967Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M14.1667 9.99967C14.1667 9.0792 14.9129 8.33301 15.8333 8.33301C16.7538 8.33301 17.5 9.0792 17.5 9.99967C17.5 10.9201 16.7538 11.6663 15.8333 11.6663C14.9129 11.6663 14.1667 10.9201 14.1667 9.99967Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M2.5 9.99967C2.5 9.0792 3.24619 8.33301 4.16667 8.33301C5.08714 8.33301 5.83333 9.0792 5.83333 9.99967C5.83333 10.9201 5.08714 11.6663 4.16667 11.6663C3.24619 11.6663 2.5 10.9201 2.5 9.99967Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M8.5 6C8.5 5.44772 8.94772 5 9.5 5C10.0523 5 10.5 5.44772 10.5 6C10.5 6.55228 10.0523 7 9.5 7C8.94772 7 8.5 6.55228 8.5 6Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M1.5 6C1.5 5.44772 1.94772 5 2.5 5C3.05228 5 3.5 5.44772 3.5 6C3.5 6.55228 3.05228 7 2.5 7C1.94772 7 1.5 6.55228 1.5 6Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.66667 8.00033C6.66667 7.26395 7.26362 6.66699 8 6.66699C8.73638 6.66699 9.33333 7.26395 9.33333 8.00033C9.33333 8.73671 8.73638 9.33366 8 9.33366C7.26362 9.33366 6.66667 8.73671 6.66667 8.00033Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M11.3333 8.00033C11.3333 7.26395 11.9303 6.66699 12.6667 6.66699C13.403 6.66699 14 7.26395 14 8.00033C14 8.73671 13.403 9.33366 12.6667 9.33366C11.9303 9.33366 11.3333 8.73671 11.3333 8.00033Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M2 8.00033C2 7.26395 2.59695 6.66699 3.33333 6.66699C4.06971 6.66699 4.66667 7.26395 4.66667 8.00033C4.66667 8.73671 4.06971 9.33366 3.33333 9.33366C2.59695 9.33366 2 8.73671 2 8.00033Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.33333 9.99967C8.33333 9.0792 9.07952 8.33301 10 8.33301C10.9205 8.33301 11.6667 9.0792 11.6667 9.99967C11.6667 10.9201 10.9205 11.6663 10 11.6663C9.07952 11.6663 8.33333 10.9201 8.33333 9.99967Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M14.1667 9.99967C14.1667 9.0792 14.9129 8.33301 15.8333 8.33301C16.7538 8.33301 17.5 9.0792 17.5 9.99967C17.5 10.9201 16.7538 11.6663 15.8333 11.6663C14.9129 11.6663 14.1667 10.9201 14.1667 9.99967Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M2.5 9.99967C2.5 9.0792 3.24619 8.33301 4.16667 8.33301C5.08714 8.33301 5.83333 9.0792 5.83333 9.99967C5.83333 10.9201 5.08714 11.6663 4.16667 11.6663C3.24619 11.6663 2.5 10.9201 2.5 9.99967Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconDotsHorizontal: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"dots-horizontal"} {...props} />
);
